import React from "react"
import {PropTypes} from 'prop-types';


import { Media } from 'reactstrap';
import {Col} from "reactstrap";

import icons from './icons'
import EntryIcon from "./EntryIcon";
import SubEntry from "./SubEntry";
import Moment from "react-moment";

export default class Entry extends React.Component {

  render() {
    const {timestamp, title, status, icon, entries} = this.props
    const titles = {
      'tasks.prepare': "Prepare",
      'tasks.download': "Download",
      'tasks.extract': "Extract",
      'tasks.virusscan': "Virus scan",
      'tasks.filescan': "File scan",
      'tasks.shred': "Shred leftovers",
      'tasks.finalize': "Rounding up",
    }
    return <Media>
      <Media left>
        <EntryIcon icon={icon} color={status}/>
      </Media>
      <Media body>
        <Media heading>{titles[title]||title} <small><Moment fromNow date={timestamp}/></small></Media>
        <ul style={{listStyle:'none',paddingLeft:'0'}}>
          {entries.map((entry) => <SubEntry timestamp={entry.timestamp}>{entry.content}</SubEntry>)}
        </ul>
      </Media>
    </Media>
  }
}

Entry.propTypes = {
  timestamp: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  status: PropTypes.oneOf(['success', 'warning', 'danger']),
  icon: PropTypes.string,
  entries: PropTypes.array,
};

Entry.defaultProps = {
  title: 'Task title',
  status: 'success',
  icon: 'beer',
  entries: []
};


// WEBPACK FOOTER //
// ./src/components/Verification/Timeline/Entry.js